export default "__VITE_ASSET__0352ba04__"